import { useTranslation } from 'react-i18next';

import { TextField, Typography } from '@packages/fenrir/components';
import { Stack } from '@packages/fenrir/components/stack';

type ScannerNameFieldProps = {
  scannerNameFieldValue: string;
  onScannerNameChange: (scannerName: string) => void;
  editable: boolean;
  editMode: boolean;
  errorMessage: string;
};

const scannerNameFieldTruncateStyles = {
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: '2',
  overflow: 'hidden',
  display: '-webkit-box',
  wordBreak: 'break-word',
};

export const ScannerNameField: React.FC<ScannerNameFieldProps> = ({
  scannerNameFieldValue,
  onScannerNameChange,
  editable,
  editMode,
  errorMessage,
}) => {
  const { t } = useTranslation('telemetryScannerConfig');

  if (!editable) {
    return (
      <Stack>
        <Typography variant="body2" sx={scannerNameFieldTruncateStyles}>
          {scannerNameFieldValue}
        </Typography>
        <Typography color="warning" variant="body2">
          {t('scannerInformation.scannerNameWarning')}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack>
      {editMode ? (
        <Stack>
          <TextField
            error={Boolean(errorMessage)}
            disabled={!editMode}
            value={scannerNameFieldValue}
            onChange={(e) => {
              onScannerNameChange(e.target.value);
            }}
          />
          <Typography color="error" variant="body2">
            {errorMessage}
          </Typography>
        </Stack>
      ) : (
        <Typography variant="body2" sx={scannerNameFieldTruncateStyles}>
          {scannerNameFieldValue}
        </Typography>
      )}
    </Stack>
  );
};
